import htmlDe from './embed_de.html';
import htmlEn from './embed_en.html';

const html = {
  de: htmlDe,
  en: htmlEn,
};

((self) => {
  // Shim NodeList.prototype.forEach
  if (typeof NodeList.prototype.forEach !== 'function') {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

  // eslint-disable-next-line
  self.embedEhealthMap = (id, apiUrl, lang) => {
    const $target = document.getElementById(id);
    if ($target) {
      // 1. Domain herausfinden
      const embedScript = document.getElementById('ehealth-map-script');
      const scriptSrc = embedScript.getAttribute('src');

      const tmpLink = document.createElement('a');
      tmpLink.href = scriptSrc;
      const { href } = tmpLink;

      const baseUrl = href.replace('/assets/ehealth-map-embed.js', '');

      // 2. Stylesheet einbinden nach <head>
      const $link = document.createElement('link');
      $link.href = `${baseUrl}/assets/main.css`;
      $link.rel = 'stylesheet';
      $link.type = 'text/css';

      document.head.appendChild($link);

      // 3. HTML rein packen
      $target.innerHTML = html[lang];
      const $container = $target.querySelector('.ehealth-map');
      $container.setAttribute('data-api-url', apiUrl);
      $container.setAttribute('data-lang', lang);

      // 4. Script laden nach <head>
      const $script = document.createElement('script');
      $script.src = `${baseUrl}/assets/index.js`;

      document.body.appendChild($script);
    }
  };
})(window);
